export interface AntdComponentMarker {
  className: string
  componentName: string
}

export const ANTD_COMPONENT_ROOTS = [
  { className: 'anticon', componentName: 'Icon' },
  { className: 'ant-affix', componentName: 'Affix' },
  { className: 'ant-alert', componentName: 'Alert' },
  { className: 'ant-anchor', componentName: 'Anchor' },
  { className: 'ant-avatar', componentName: 'Avatar' },
  { className: 'ant-badge', componentName: 'Badge' },
  { className: 'ant-breadcrumb', componentName: 'Breadcrumb' },
  { className: 'ant-btn', componentName: 'Button' },
  { className: 'ant-calendar', componentName: 'Calendar' },
  { className: 'ant-card', componentName: 'Card' },
  { className: 'ant-cascader', componentName: 'Cascader' },
  { className: 'ant-checkbox-wrapper', componentName: 'Checkbox' },
  { className: 'ant-collapse', componentName: 'Collapse' },
  { className: 'ant-color-picker', componentName: 'ColorPicker' },
  { className: 'ant-descriptions', componentName: 'Descriptions' },
  { className: 'ant-divider', componentName: 'Divider' },
  { className: 'ant-drawer', componentName: 'Drawer' },
  { className: 'ant-dropdown', componentName: 'Dropdown' },
  { className: 'ant-empty', componentName: 'Empty' },
  { className: 'ant-flex', componentName: 'Flex' },
  { className: 'ant-form', componentName: 'Form' },
  { className: 'ant-image', componentName: 'Image' },
  { className: 'ant-input-affix-wrapper', componentName: 'Input' },
  { className: 'ant-input-number', componentName: 'InputNumber' },
  { className: 'ant-input-otp', componentName: 'InputOTP' },
  { className: 'ant-input', componentName: 'Input' },
  { className: 'ant-layout', componentName: 'Layout' },
  { className: 'ant-list', componentName: 'List' },
  { className: 'ant-mentions', componentName: 'Mentions' },
  { className: 'ant-menu', componentName: 'Menu' },
  { className: 'ant-message', componentName: 'Message' },
  { className: 'ant-modal', componentName: 'Modal' },
  { className: 'ant-notification-notice', componentName: 'Notification' },
  { className: 'ant-pagination', componentName: 'Pagination' },
  { className: 'ant-picker', componentName: 'DatePicker' },
  { className: 'ant-popconfirm', componentName: 'Popconfirm' },
  { className: 'ant-popover', componentName: 'Popover' },
  { className: 'ant-progress', componentName: 'Progress' },
  { className: 'ant-qrcode', componentName: 'QRCode' },
  { className: 'ant-radio-group', componentName: 'Radio' },
  { className: 'ant-radio-wrapper', componentName: 'Radio' },
  { className: 'ant-rate', componentName: 'Rate' },
  { className: 'ant-result', componentName: 'Result' },
  { className: 'ant-segmented', componentName: 'Segmented' },
  { className: 'ant-select', componentName: 'Select' },
  { className: 'ant-skeleton', componentName: 'Skeleton' },
  { className: 'ant-slider', componentName: 'Slider' },
  { className: 'ant-space', componentName: 'Space' },
  { className: 'ant-spin', componentName: 'Spin' },
  { className: 'ant-steps', componentName: 'Steps' },
  { className: 'ant-switch', componentName: 'Switch' },
  { className: 'ant-table', componentName: 'Table' },
  { className: 'ant-tabs', componentName: 'Tabs' },
  { className: 'ant-tag', componentName: 'Tag' },
  { className: 'ant-timeline', componentName: 'Timeline' },
  { className: 'ant-tooltip', componentName: 'Tooltip' },
  { className: 'ant-tour', componentName: 'Tour' },
  { className: 'ant-transfer', componentName: 'Transfer' },
  { className: 'ant-tree', componentName: 'Tree' },
  { className: 'ant-upload-wrapper', componentName: 'Upload' },
] as const satisfies readonly AntdComponentMarker[]

const rootsByClassName = new Map<string, AntdComponentMarker>(
  ANTD_COMPONENT_ROOTS.map((marker) => [marker.className, marker])
)

function getAntdIconComponentName(element: Element): string {
  const iconClassName = Array.from(element.classList).find(
    (className) => className.startsWith('anticon-') && className !== 'anticon-spin'
  )
  if (!iconClassName) return 'Icon'

  const name = iconClassName
    .slice('anticon-'.length)
    .split('-')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join('')

  return `${name}Outlined`
}

export function getAntdComponentMarker(target: Element | null): AntdComponentMarker | null {
  let element = target

  while (element) {
    for (const className of element.classList) {
      const marker = rootsByClassName.get(className)
      if (marker) {
        return marker.className === 'anticon'
          ? { ...marker, componentName: getAntdIconComponentName(element) }
          : marker
      }
    }

    element = element.parentElement
  }

  return null
}
